import axios from "axios";

const API_URL = `${process.env.GATSBY_STRAPI_URL}/auth/local`;
const isBrowser = typeof window !== `undefined`

export const getUser = () =>
  isBrowser && window.localStorage.gatsbyUser
    ? JSON.parse(window.localStorage.gatsbyUser)
    : {}

const setUser = user => (window.localStorage.gatsbyUser = JSON.stringify(user))

export const login = async (state, token) => {
  const identifier = state.username;
  const password = state.password;
  return await axios
    .post(API_URL, {
      identifier,
      password,
      captchaResponse: token
    })
    .then((response) => {
      if (response.data.jwt) {
        setUser(response.data.user)
        localStorage.setItem("jwt", response.data.jwt)
      }
    });
};
export const logout = callback => {
  setUser({})
  localStorage.removeItem("jwt")
  callback()
};
export const getCurrentUser = () => isBrowser && getUser()

export const isLoggedIn = () => {
  return isBrowser && localStorage.getItem("jwt") && JSON.parse(localStorage.getItem("gatsbyUser"))?.email;
}
